// Class: lime.graphics.cairo._CairoImageSurface.CairoImageSurface_Impl_

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../../hxClasses_stub").default;
var $hxEnums = require("./../../../../hxEnums_stub").default;
var $import = require("./../../../../import_stub").default;
function lime_utils__$DataPointer_DataPointer_$Impl_$() {return require("./../../../../lime/utils/_DataPointer/DataPointer_Impl_");}

// Constructor

var CairoImageSurface_Impl_ = function(){}

// Meta

CairoImageSurface_Impl_.__name__ = "lime.graphics.cairo._CairoImageSurface.CairoImageSurface_Impl_";
CairoImageSurface_Impl_.__isInterface__ = false;
CairoImageSurface_Impl_.prototype = {
	
};
CairoImageSurface_Impl_.prototype.__class__ = CairoImageSurface_Impl_.prototype.constructor = $hxClasses["lime.graphics.cairo._CairoImageSurface.CairoImageSurface_Impl_"] = CairoImageSurface_Impl_;

// Init



// Statics

CairoImageSurface_Impl_._new = function(format,width,height) {
	var this1 = 0;
	return this1;
}
CairoImageSurface_Impl_.create = function(data,format,width,height,stride) {
	return 0;
}
CairoImageSurface_Impl_.fromImage = function(image) {
	return null;
}
CairoImageSurface_Impl_.get_data = function(this1) {
	return (lime_utils__$DataPointer_DataPointer_$Impl_$().default).fromFloat(0);
}
CairoImageSurface_Impl_.get_format = function(this1) {
	return 0;
}
CairoImageSurface_Impl_.get_height = function(this1) {
	return 0;
}
CairoImageSurface_Impl_.get_stride = function(this1) {
	return 0;
}
CairoImageSurface_Impl_.get_width = function(this1) {
	return 0;
}


// Export

exports.default = CairoImageSurface_Impl_;